// extracted by mini-css-extract-plugin
export default {"introSection":"IpadPage_introSection__vI1+k"};